<script lang="ts">
  // BJL-CHECK: Button (used), Alert. The toggle is a bjl Button. The surround stays custom:
  // bjl Alert paints from a semantic tone (info/warn/error) and this banner is neutral
  // chrome carrying a route-colored bullet. See artifacts/deviations/TransferBanner.md.
  //
  // Header shown on a stop sheet reached by transferring. It names the vehicle that brings
  // the rider here and when, and toggles the filter; a rider who changes their mind still
  // needs to see what's actually at the platform now.
  import { Button } from '@byjackli-labs/ui/Button'
  import { Colors, getRouteColor } from '../../ui/colors'
  import { cardChrome, Type } from '../../ui/theme'
  import { fmtClock, type TransferContext } from './timetable'
  import RouteBadge from '../RouteBadge.svelte'

  interface Props {
    ctx: TransferContext
    /** Whether the "only later connections" filter is currently applied. */
    active: boolean
    onToggle: () => void
  }

  const { ctx, active, onToggle }: Props = $props()

  const color = $derived(getRouteColor(ctx.routeId))
</script>

<div
  style="
    display: flex; align-items: center; gap: 10px;
    {cardChrome()} padding: 12px 14px; margin-top: 16px;
  "
>
  <!-- The route's own color as a 6px bar, matching every other inline notice in the app
       (the alerts index, the detour strip on a bus stop): a colored edge is how this design
       says "this concerns that line" without spending a badge on it. -->
  <span
    aria-hidden="true"
    style="width: 6px; height: 28px; border-radius: 3px; flex-shrink: 0; background-color: {color};"
  ></span>
  <RouteBadge routeId={ctx.routeId} size={22} />
  <div style="flex: 1; min-width: 0;">
    <div style="color: {Colors.text}; {Type.bodyStrong};">
      You arrive at {fmtClock(ctx.arriveAt)}
    </div>
    <div style="color: {Colors.textMuted}; {Type.caption}; margin-top: 1px;">
      {active ? 'Showing only connections after that' : 'Showing everything live'}
    </div>
  </div>
  <Button
    variant="secondary"
    size="sm"
    onclick={onToggle}
    aria-pressed={active}
    style="flex-shrink: 0; white-space: nowrap;"
  >
    {active ? 'Show all' : 'Filter'}
  </Button>
</div>
